import React from 'react';
import { FormattedMessage } from 'react-intl';
import { string } from 'prop-types';
import classnames from 'classnames';
import './VATExcludedLabel.scss';

export default function VATExcludedLabel({ locale }) {
    const rootClassNames = classnames('prices__vat-excluded', {
        'prices__vat-excluded--padded': ['es', 'it'].includes(
            locale.toLowerCase(),
        ),
    });
    return (
        <span className={rootClassNames}>
            <FormattedMessage
                id="listing.price.vatExcluded"
                defaultMessage=" ex VAT"
                description="VAT excluded label of price"
            />
        </span>
    );
}

VATExcludedLabel.propTypes = {
    locale: string.isRequired,
};
